export const collectionDropdown2_data = [
  {
    id: "0CryptoKitties",
    text: "CryptoKitties",
    image: "/images/avatars/collection_ava_1.png",
  },
  {
    id: "1KaijuKings",
    text: "KaijuKings",
    image: "/images/avatars/collection_ava_2.jpg",
  },
  {
    id: "2Kumo x World",
    text: "Kumo x World",
    image: "/images/avatars/collection_ava_3.png",
  },
  {
    id: "3Irene DAO",
    text: "Irene DAO",
    image: "/images/avatars/collection_ava_4.jpg",
  },
  {
    id: "4GenerativeDungeon",
    text: "GenerativeDungeon",
    image: "/images/avatars/collection_ava_5.png",
  },
  {
    id: "5ENS Domains",
    text: "ENS Domains",
    image: "/images/avatars/collection_ava_6.jpg",
  },
  {
    id: "6Cozy Penguin",
    text: "Cozy Penguin",
    image: "/images/avatars/collection_ava_7.png",
  },
];
export const EthereumDropdown2_data = [
  {
    id: "0Ethereum",
    text: "Ethereum",
    image: "/images/chains/ETH.png",
  },
  {
    id: "1Flow",
    text: "Flow",
    image: "/images/chains/FLOW.png",
  },
  {
    id: "2FUSD",
    text: "FUSD",
    image: "/images/chains/FUSD.png",
  },
];
